/**
 * Created by hernanherreros on 2019-07-05
 */

import * as React from 'react'

export const getCongressSlug = (alias: string) => congressAliases.hasOwnProperty(alias) ? congressAliases[alias] : alias
export const getCongressAlias = (slug: string) => {
  const congressAlias = Object.keys(congressAliases).find(c => congressAliases[c] === slug)
  return congressAlias || slug
}
export const isAlias = (alias: string) => {
  const congressAlias = Object.keys(congressAliases).find(c => congressAliases[c] === alias)
  return !!congressAlias
}

const congressAliases: any = {
  expoEdificaConexpoLatinAmerica2019: 'expoedifica2019',
  trazoevents: 'lowcost'
}

export const disabledCongresses = [
  'veterinario2019',
  'expoedifica2019',
]
